export {
    getNewsData
};
import i18n from '../i18n'

function getNewsData() {
    return [{
            img: '新闻16.jpg',
            title: i18n.t('新闻16标题'),
            newsBrand: i18n.t("仙桃电视台"),
            date: '2020-09-09',
            url: "https://mp.weixin.qq.com/s/sAVSjfd2L7fLFFgm5x5NmA",
            info: [{
                type: 'text',
                value: i18n.t('新闻16text1')
            }, {
                type: 'text',
                value: i18n.t('新闻16text2')
            }, {
                type: 'text',
                value: i18n.t('新闻16text3')
            }, {
                type: 'text',
                value: i18n.t('新闻16text4')
            }, {
                type: 'text',
                value: i18n.t('新闻16text5')
            }, {
                type: 'text',
                value: i18n.t('新闻16text6')
            }, {
                type: 'text',
                value: i18n.t('新闻16text7')
            }, {
                type: 'text',
                value: i18n.t('新闻16text8')
            }, {
                type: 'text',
                value: i18n.t('新闻16text9')
            }, {
                type: 'text',
                value: i18n.t('新闻16text10')
            }, {
                type: 'text',
                value: i18n.t('新闻16text11')
            }, {
                type: 'text',
                value: i18n.t('新闻16text12')
            }, {
                type: 'text',
                value: i18n.t('新闻16text13')
            }, {
                type: 'img',
                url: '16-1.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text14')
            }, {
                type: 'text',
                value: i18n.t('新闻16text15')
            }, {
                type: 'text',
                value: i18n.t('新闻16text16')
            }, {
                type: 'text',
                value: i18n.t('新闻16text17')
            }, {
                type: 'text',
                value: i18n.t('新闻16text18')
            }, {
                type: 'img',
                url: '16-2.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text19')
            }, {
                type: 'text',
                value: i18n.t('新闻16text20')
            }, {
                type: 'img',
                url: '16-3.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text21')
            }, {
                type: 'text',
                value: i18n.t('新闻16text22')
            }, {
                type: 'img',
                url: '16-4.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text23')
            }, {
                type: 'text',
                value: i18n.t('新闻16text24')
            }, {
                type: 'text',
                value: i18n.t('新闻16text25')
            }, {
                type: 'img',
                url: '16-5.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text26')
            }, {
                type: 'text',
                value: i18n.t('新闻16text27')
            }, {
                type: 'text',
                value: i18n.t('新闻16text28')
            }, {
                type: 'text',
                value: i18n.t('新闻16text29')
            }, {
                type: 'img',
                url: '16-6.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text30')
            }, {
                type: 'img',
                url: '16-7.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text31')
            }, {
                type: 'img',
                url: '新闻16.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻16text32')
            }, {
                type: 'text',
                value: i18n.t('新闻16text33')
            }, {
                type: 'text',
                value: i18n.t('新闻16text34')
            }, ]
        },
        {
            img: '17-2.jpg',
            title: i18n.t("新闻17标题"),
            newsBrand: i18n.t("党员生活"),
            date: '2020-07-14',
            url: "https://mp.weixin.qq.com/s/CjVpUThb-SpCctAp7IgVpQ",
            info: [{
                type: 'text',
                value: i18n.t('新闻17text1')
            }, {
                type: 'text',
                value: i18n.t('新闻17text2')
            }, {
                type: 'text',
                value: i18n.t('新闻17text3')
            }, {
                type: 'text',
                value: i18n.t('新闻17text4')
            }, {
                type: 'text',
                value: i18n.t('新闻17text5')
            }, {
                type: 'text',
                value: i18n.t('新闻17text6')
            }, {
                type: 'text',
                value: i18n.t('新闻17text7')
            }, {
                type: 'text',
                value: i18n.t('新闻17text8')
            },{
                type: 'img',
                url: '17-1.jpg'
            },
            {
                type: 'text',
                value: i18n.t('新闻17text9')
            }, {
                type: 'text',
                value: i18n.t('新闻17text10')
            }, {
                type: 'text',
                value: i18n.t('新闻17text11')
            }, {
                type: 'text',
                value: i18n.t('新闻17text12')
            }, {
                type: 'text',
                value: i18n.t('新闻17text13')
            }, {
                type: 'text',
                value: i18n.t('新闻17text14')
            }, {
                type: 'text',
                value: i18n.t('新闻17text15')
            }, {
                type: 'text',
                value: i18n.t('新闻17text16')
            }, {
                type: 'text',
                value: i18n.t('新闻17text17')
            }, {
                type: 'text',
                value: i18n.t('新闻17text18')
            }, {
                type: 'text',
                value: i18n.t('新闻17text19')
            }, {
                type: 'text',
                value: i18n.t('新闻17text20')
            }, {
                type: 'text',
                value: i18n.t('新闻17text21')
            }
            ,{
                type: 'img',
                url: '17-2.jpg'
            },
             {
                type: 'text',
                value: i18n.t('新闻17text22')
            }, {
                type: 'text',
                value: i18n.t('新闻17text23')
            }, {
                type: 'text',
                value: i18n.t('新闻17text24')
            }, {
                type: 'text',
                value: i18n.t('新闻17text25')
            }, {
                type: 'text',
                value: i18n.t('新闻17text26')
            }
            ,{
                type: 'img',
                url: '17-3.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻17text27')
            }, {
                type: 'text',
                value: i18n.t('新闻17text28')
            }, {
                type: 'text',
                value: i18n.t('新闻17text29')
            }, {
                type: 'text',
                value: i18n.t('新闻17text30')
            },
            {
                type: 'img',
                url: '17-4.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻17text31')
            }, {
                type: 'text',
                value: i18n.t('新闻17text32')
            }, {
                type: 'text',
                value: i18n.t('新闻17text33')
            }, {
                type: 'text',
                value: i18n.t('新闻17text34')
            }, {
                type: 'text',
                value: i18n.t('新闻17text35')
            }, {
                type: 'text',
                value: i18n.t('新闻17text36')
            }, {
                type: 'text',
                value: i18n.t('新闻17text37')
            }, 
            {
                type: 'img',
                url: '17-5.jpg'
            },{
                type: 'text',
                value: i18n.t('新闻17text38')
            }, {
                type: 'text',
                value: i18n.t('新闻17text39')
            }, {
                type: 'text',
                value: i18n.t('新闻17text40')
            }, {
                type: 'text',
                value: i18n.t('新闻17text41')
            }, {
                type: 'text',
                value: i18n.t('新闻17text42')
            },{
                type: 'img',
                url: '17-6.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻17text43')
            }, {
                type: 'text',
                value: i18n.t('新闻17text44')
            }, {
                type: 'text',
                value: i18n.t('新闻17text45')
            }, {
                type: 'text',
                value: i18n.t('新闻17text46')
            }, {
                type: 'text',
                value: i18n.t('新闻17text47')
            }
            ,{
                type: 'img',
                url: '17-7.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻17text48')
            }, {
                type: 'text',
                value: i18n.t('新闻17text49')
            }, {
                type: 'text',
                value: i18n.t('新闻17text50')
            }, {
                type: 'text',
                value: i18n.t('新闻17text51')
            }
            ,{
                type: 'img',
                url: '17-8.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻17text52')
            }, {
                type: 'text',
                value: i18n.t('新闻17text53')
            }, ]
        },
        {
            img: '新闻15.jpg',
            title: i18n.t('仙桃彭场镇：从“一业”到“一园” “疫”后升级的无纺布小镇'),
            newsBrand: i18n.t("仙桃日报"),
            date: '2020-06-03',
            url: "http://m.hbtv.com.cn/p/1851118.html",
            info: [{
                type: 'video',
                url: '15_1.mp4'
            }]
        },
        {
            img: '新闻14.jpg',
            title: i18n.t('.仙桃新“网红”！她为省指挥部提供46万件医用防护服'),
            newsBrand: i18n.t("仙桃日报"),
            date: '2020-06-03',
            url: "https://mp.weixin.qq.com/s/cqQ01lVToViQ3--cvA6ABQ",
            info: [{
                    type: 'img',
                    url: '14-1.png'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻14text1')
                },
                {
                    type: 'img',
                    url: '14-2.png'
                }, {
                    type: 'text',
                    value: i18n.t('新闻14text2')
                }, {
                    type: 'img',
                    url: '14-3.png'
                }, {
                    type: 'text',
                    value: i18n.t('新闻14text3')
                }, {
                    type: 'img',
                    url: '14-4.png'
                }, {
                    type: 'text',
                    value: i18n.t('新闻14text4')
                }, {
                    type: 'img',
                    url: '14-5.png'
                }, {
                    type: 'text',
                    value: i18n.t('新闻14text5')
                }, {
                    type: 'img',
                    url: '14-6.png'
                }, {
                    type: 'text',
                    value: i18n.t('新闻14text6')
                }, {
                    type: 'img',
                    url: '14-7.png'
                }, {
                    type: 'text',
                    value: i18n.t('新闻14text7')
                }
            ]
        },
        {
            img: '新闻13.jpg',
            title: i18n.t('彭场：非织造布名镇的世界级眼光'),
            newsBrand: i18n.t("湖北日报"),
            date: '2020-04-20',
            url: "https://epaper.hubeidaily.net/pad/content/202004/20/content_26712.html",
            info: [{
                    type: 'img',
                    url: '新闻13_1.jpg'
                },
                {
                    type: 'img',
                    url: '新闻13_2.jpg'
                }
            ]
        },
        {
            img: '新闻1.jpg',
            title: i18n.t('湖北省疫情防控指挥部向誉诚致来感谢信'),
            newsBrand: i18n.t("誉诚防护"),
            date: '2020-04-06',
            url: "",
            info: [{
                type: 'img',
                url: '新闻1_1.jpg'
            }]
        },
        {
            img: '新闻2.jpg',
            title: i18n.t('湖北仙桃 开足马力 生产医用防护物资'),
            newsBrand: i18n.t("朝闻天下"),
            date: '2020-03-05',
            url: "http://tv.cctv.com/2020/03/05/VIDEMVWxXb6iW0uRzatXqnRb200305.shtml",
            info: [{
                type: 'video',
                url: '新闻2.mp4'
            }]
        },
        {
            img: '新闻3.jpg',
            title: i18n.t('央视《新闻联播》聚焦仙桃！这次是因为……'),
            newsBrand: i18n.t("仙桃发布"),
            date: '2020-03-03',
            url: 'https://mp.weixin.qq.com/s/RgNwdgDthh2D_vvD6QatgQ',
            info: [{
                    type: 'text',
                    value: i18n.t('新闻3text2')
                },
                {
                    type: 'video',
                    url: '新闻3.mp4'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻3text1')
                }
            ]
        },
        {
            img: '新闻4.jpg',
            title: i18n.t('小城市，大担当，仙桃上了央视《新闻联播》！'),
            newsBrand: i18n.t("仙桃电视台"),
            date: '2020-03-03',
            url: "https://mp.weixin.qq.com/s/wR75zEOrl7-2Z1AaTbQ_lw",
            info: [{
                    type: 'text',
                    value: i18n.t('新闻4text1')
                },
                {
                    type: 'video',
                    url: '新闻3.mp4'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text2')
                },
                {
                    type: 'img',
                    url: '新闻4_1.gif'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text3')
                },
                {
                    type: 'img',
                    url: '新闻4_2.jpg'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text4')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text5')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text6')
                },
                {
                    type: 'img',
                    url: '新闻4_3.jpg'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text7')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻4text8')
                }
            ]
        },
        {
            img: '新闻5.jpg',
            title: i18n.t('即使出现几天零增长，疫情防控也丝毫不能放松！应勇强调保持定力、咬紧牙关'),
            newsBrand: i18n.t("湖北日报"),
            date: '2020-03-02',
            url: "https://mp.weixin.qq.com/s/vxXgCxgH1jwStIxsYIXLAg",
            info: [{
                    type: 'text',
                    value: i18n.t('新闻5text1')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻5text2')
                },
                {
                    type: 'img',
                    url: '新闻5_1.jpg'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻5text3')
                }
            ]
        },
        {
            img: '新闻6.jpg',
            title: i18n.t('湖北日报关注仙桃：“停不得”企业就是“兵工厂”'),
            newsBrand: i18n.t("湖北日报"),
            date: '2020-03-02',
            url: "https://mp.weixin.qq.com/s/A53swJSiJ2dzT8xcGcJAEA",
            info: [{
                    type: 'text',
                    value: i18n.t('新闻6text1'),
                },
                {
                    type: 'img',
                    url: '新闻6_1.jpg'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻6text2'),
                },
                {
                    type: 'text',
                    value: i18n.t('新闻6text3'),
                },
                {
                    type: 'text',
                    value: i18n.t('新闻6text4'),
                },
                {
                    type: 'text',
                    value: i18n.t('新闻6text5'),
                },
                {
                    type: 'text',
                    value: i18n.t('新闻6text6'),
                },
                {
                    type: 'text',
                    value: i18n.t('新闻6text7'),
                },
            ]
        },
        {
            img: '新闻7.jpg',
            title: i18n.t('每天，1.4万套防护服从这里发出'),
            newsBrand: i18n.t("湖北日报"),
            date: '2020-02-24',
            url: "https://epaper.hubeidaily.net/pad/content/202002/24/content_21869.html?from=groupmessage&isappinstalled=0",
            info: [{
                    type: 'text',
                    value: i18n.t('新闻7text1')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text2')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text3')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text4')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text5')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text6')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text7')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text8')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text9')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text10')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text11')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text12')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text13')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻7text14')
                }, {
                    type: 'text',
                    value: i18n.t('新闻7text15')
                }, {
                    type: 'text',
                    value: i18n.t('新闻7text16')
                }, {
                    type: 'text',
                    value: i18n.t('新闻7text17')
                }, {
                    type: 'text',
                    value: i18n.t('新闻7text18')
                }, {
                    type: 'text',
                    value: i18n.t('新闻7text19')
                }, {
                    type: 'text',
                    value: i18n.t('新闻7text20')
                }
            ]
        },
        {
            img: '新闻8.jpg',
            title: i18n.t('保供一线 开足马力！湖北防护服、N95口罩自产占比55% 、90%'),
            newsBrand: i18n.t("湖北广电"),
            date: '2020-02-12',
            url: "http://m.hbtv.com.cn/p/1782035.html",
            info: [{
                    type: 'video',
                    url: '新闻8_1.mp4'
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text1')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text2')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text3')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text4')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text5')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text6')
                },
                {
                    type: 'text',
                    value: i18n.t('新闻8text7')
                }
            ]
        }, {
            img: '新闻9.jpg',
            title: i18n.t('立下军令状，小城大担当 湖北仙桃：今起日供医用防护服3万套'),
            newsBrand: i18n.t("人民网-人民日报"),
            date: '2020-02-12',
            url: "http://society.people.com.cn/n1/2020/0208/c1008-31577555.html?from=groupmessage&isappinstalled=0",
            info: [{
                type: 'text',
                value: i18n.t('新闻9text1')
            }, {
                type: 'text',
                value: i18n.t('新闻9text2')
            }, {
                type: 'text',
                value: i18n.t('新闻9text3')
            }, {
                type: 'text',
                value: i18n.t('新闻9text4')
            }, {
                type: 'text',
                value: i18n.t('新闻9text5')
            }, {
                type: 'text',
                value: i18n.t('新闻9text6')
            }, {
                type: 'text',
                value: i18n.t('新闻9text7')
            }]
        },
        {
            img: '新闻10.jpg',
            title: i18n.t('仙桃公布疫情防控物资重点生产60家企业名单'),
            newsBrand: i18n.t("仙桃日报"),
            date: '2020-02-04',
            url: "http://m.hbtv.com.cn/p/1775541.html",
            info: [{
                    type: 'text',
                    value: i18n.t('新闻10text1')
                },
                {
                    type: 'img',
                    url: '新闻10_1.jpg'
                }, {
                    type: 'img',
                    url: '新闻10_2.jpg'
                }
            ]
        },
        {
            img: '新闻11.jpg',
            title: i18n.t('战“疫”保电刻不容缓 仙桃市日产防护服必达3万件'),
            newsBrand: i18n.t("湖北广电"),
            date: '2020-02-02',
            url: "https://mp.weixin.qq.com/s/n_0JAfTg5yeEawfXvq2pJg",
            info: [{
                type: 'text',
                value: i18n.t('新闻11text1')
            }, {
                type: 'img',
                url: '新闻11_1.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻11text2')
            }, {
                type: 'text',
                value: i18n.t('新闻11text3')
            }, {
                type: 'text',
                value: i18n.t('新闻11text4')
            }, {
                type: 'text',
                value: i18n.t('新闻11text5')
            }, {
                type: 'text',
                value: i18n.t('新闻11text6')
            }, {
                type: 'text',
                value: i18n.t('新闻11text7')
            }]
        },
        {
            img: '新闻12.jpg',
            title: i18n.t('终于来了！全国500家口罩、防护服生产厂家通讯录！天佑中华，祈福华夏！'),
            newsBrand: i18n.t("环球纺织"),
            date: '2020-01-29',
            url: "https://mp.weixin.qq.com/s/n_0JAfTg5yeEawfXvq2pJg",
            info: [{
                type: 'img',
                url: '新闻12.jpg'
            }, {
                type: 'text',
                value: i18n.t('新闻12text1')
            }, {
                type: 'text',
                value: i18n.t('新闻12text2')
            }]
        }
    ]
}